module.exports = __webpack_public_path__ + "static/media/ios-today.005e2e03.svg";